/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_System_Filter_LabelInputs */

const bn_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফিল্টার`)
};

const de_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FILTER`)
};

const el_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ΦΙΛΤΡΟ`)
};

const en_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FILTER`)
};

const es_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FILTRAR`)
};

const fr_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FILTRE`)
};

const hi_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़िल्टर`)
};

const hu_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SZŰRŐ`)
};

const id_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MENYARING`)
};

const it_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FILTRO`)
};

const ja_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィルター`)
};

const ko_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`필터`)
};

const nl_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FILTER`)
};

const pl_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FILTR`)
};

const pt_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FILTRO`)
};

const ru_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ФИЛЬТР`)
};

const sv_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FILTRERA`)
};

const tr_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FİLTRE`)
};

const uk_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ФІЛЬТР`)
};

const vi_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LỌC`)
};

const zh_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`筛选`)
};

const zh_hant_cipher_system_filter_label = /** @type {(inputs: Cipher_System_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`篩選`)
};

/**
* | output |
* | --- |
* | "FILTER" |
*
* @param {Cipher_System_Filter_LabelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_system_filter_label = /** @type {((inputs?: Cipher_System_Filter_LabelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_System_Filter_LabelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_system_filter_label(inputs)
	if (locale === "de") return de_cipher_system_filter_label(inputs)
	if (locale === "el") return el_cipher_system_filter_label(inputs)
	if (locale === "en") return en_cipher_system_filter_label(inputs)
	if (locale === "es") return es_cipher_system_filter_label(inputs)
	if (locale === "fr") return fr_cipher_system_filter_label(inputs)
	if (locale === "hi") return hi_cipher_system_filter_label(inputs)
	if (locale === "hu") return hu_cipher_system_filter_label(inputs)
	if (locale === "id") return id_cipher_system_filter_label(inputs)
	if (locale === "it") return it_cipher_system_filter_label(inputs)
	if (locale === "ja") return ja_cipher_system_filter_label(inputs)
	if (locale === "ko") return ko_cipher_system_filter_label(inputs)
	if (locale === "nl") return nl_cipher_system_filter_label(inputs)
	if (locale === "pl") return pl_cipher_system_filter_label(inputs)
	if (locale === "pt") return pt_cipher_system_filter_label(inputs)
	if (locale === "ru") return ru_cipher_system_filter_label(inputs)
	if (locale === "sv") return sv_cipher_system_filter_label(inputs)
	if (locale === "tr") return tr_cipher_system_filter_label(inputs)
	if (locale === "uk") return uk_cipher_system_filter_label(inputs)
	if (locale === "vi") return vi_cipher_system_filter_label(inputs)
	if (locale === "zh") return zh_cipher_system_filter_label(inputs)
	return zh_hant_cipher_system_filter_label(inputs)
});